import { ENV } from '../env';

export interface IBayouConfig {
  companyId: string;
  environment: "staging" | "production";
  scriptUrl: string;
}

// export const BayouConfig: IBayouConfig = {
//   companyId: ENV.BAYOU_COMPANY_ID || "",
//   environment:
//     (ENV.BAYOU_ENVIRONMENT as "staging" | "production") ||
//     "staging",
//   get scriptUrl(): string {
//     return this.environment === "staging"
//       ? "https://js.staging.bayou.energy/v1"
//       : "https://js.bayou.energy/v1";
//   },
// };

const getEnvironment = (): "staging" | "production" => {
  const env = ENV.BAYOU_ENVIRONMENT;
  return env === "production" ? "production" : "staging";
};

const resolveScriptUrl = (environment: "staging" | "production") =>
  environment === "production"
    ? "https://js.bayou.energy/v1"
    : "https://js.staging.bayou.energy/v1";

const bayouEnvironment = getEnvironment();

export const BayouConfig: IBayouConfig = {
  companyId: ENV.BAYOU_COMPANY_ID || "",
  environment: bayouEnvironment,
  scriptUrl: resolveScriptUrl(bayouEnvironment),
};
